module.exports = __webpack_public_path__ + "img/loading 2.2327b838.svg";